import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import AppSmallButton from "../appComponents/UtilsComponents/AppSmallButton";
import { useAppSelector, useAppDispatch } from "../../Store";
import { useBotConfigStore } from "../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { Typography } from "@mui/material";
import  TempLogo  from "../../assets/images/startscreenlogo.png";
import { useSelector } from "react-redux";
import { botInfoStore } from "../../Store/Slices/socket/BotInfoSlice";
import AppStartScreenLanguageSelector from "../appComponents/Features/AppStartScreenLanguageSelector";
import { getLanguageSelector, setBotLanguage, setLanguageSelector } from "../../Store/Slices/socket/AllMessagesSlice";

  const ResponsiveTypography = styled(Typography)`
    && {
      font-size: 2vw;
      @media (min-width: 1200px) {
        font-size: 24px;
      }
      @media (max-width: 768px) {
        font-size: 16px;
      }
      @media (max-width: 480px) {
        font-size: 14px;
      }
    }
  `;

  const ResponsiveTitle = styled(Typography)`
    && {
      font-size: 2.5vw;
      @media (min-width: 1200px) {
        font-size: 28px;
      }
      @media (max-width: 768px) {
        font-size: 20px;
      }
      @media (max-width: 480px) {
        font-size: 16px;
      }
    }
  `;

  interface StyledLogoProps {
    isFullScreen: boolean;
  }

  const StyledLogo = styled.img<StyledLogoProps>`
    width: ${props => props.isFullScreen ? '20%' : '35%'};
  `;
  
interface StartScreenProps {
  onComplete: () => void;
  setIsLanguageSelection: any;
  setDisableStartScreen: any;
  onFormSubmitted: any;
}

const StartScreen: React.FC<StartScreenProps> = ({ onComplete, setIsLanguageSelection, setDisableStartScreen, onFormSubmitted }) => {
  const { botConfig } = useAppSelector(useBotConfigStore);
  const [showForm, setShowForm] = useState(false);
  const languageSelector = useAppSelector(getLanguageSelector);
  const dispatch = useAppDispatch();
  const { isBotSetToFullScreen } = useSelector(botInfoStore);
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: ""
  });
  const [errors, setErrors] = useState({
    email: "",
    name: "",
    phone: ""
  });
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);
  const activeLanguages = useMemo(
    () =>{
      return Array.isArray(botConfig?.chatbot?.chatbot_languages) ?
        botConfig?.chatbot?.chatbot_languages?.filter((language: any) => language?.isActive) :
        [];
    },
    [botConfig?.chatbot?.chatbot_languages]
  );

  const validateForm = () => {
    const newErrors = {
      email: "",
      name: "",
      phone: ""
    };
    let isValid = true;

    if (botConfig?.config?.start_screen?.form?.name && !formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    }

    if (botConfig?.config?.start_screen?.form?.email && !formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    }

    if (botConfig?.config?.start_screen?.form?.phone && !formData.phone.trim()) {
      newErrors.phone = "Phone is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    setErrors(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      onComplete();
    }
  };

  const startScreenConfig = useMemo(() => botConfig?.config?.start_screen, [botConfig?.config]);

  useEffect(() => {
    if (activeLanguages.length > 0) {
      dispatch(setLanguageSelector(true));
      if (!startScreenConfig) {
        setShowLanguageSelector(true);
        setIsLanguageSelection(true);
      }
    } else {
      dispatch(setLanguageSelector(false))
      dispatch(setLanguageSelector(false));
    }
  }, [activeLanguages.length, startScreenConfig, dispatch, setIsLanguageSelection, onComplete]);

  const onClickWelcomeButton = () => {
    if (botConfig?.chatbot?.multi_lingual?.multi_lingual && activeLanguages.length > 0) {
      setShowLanguageSelector(true);
      setIsLanguageSelection(true);
    } else {
      dispatch(setLanguageSelector(false));
      dispatch(setBotLanguage("english"));
      onComplete();
    }
  };

  if (!languageSelector && !startScreenConfig) {
    return null;
  }

  if (showLanguageSelector || !startScreenConfig) {
    return <AppStartScreenLanguageSelector onComplete={onComplete} />;
  }
  return (
    <StyledStartScreenWrapper style={showForm ? {justifyContent: "flex-start"} : {}}>
        <StyledInitialView>
          <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", height: "100%", gap: "20px",  }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', flexDirection: "column", height: '100%' }}>
                <StyledLogo src={TempLogo} alt="Start Screen" isFullScreen={isBotSetToFullScreen} style={{marginBottom: '20px'}} />
              
              {startScreenConfig?.title && 
              <ResponsiveTypography textAlign="center" variant="body1" style={{  maxWidth: isBotSetToFullScreen ? '80%' : '100%' }}>
                {startScreenConfig?.title}
              </ResponsiveTypography>}
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

            {startScreenConfig?.start_chat_button && (
              <AppSmallButton style={{width: isBotSetToFullScreen ? '70%' : '100%', borderRadius: '16px'}} onClick={onClickWelcomeButton}>
              {startScreenConfig.start_chat_button.text || "Start Chat"}
            </AppSmallButton>
          )}
          </div>
          </div>
          
          
        </StyledInitialView>
      {/* ) : (
        <SecondWrapper>
         <div style={{ display: "flex", alignItems: "center", flexDirection: "column", width: "100%" }}>
                <StyledLogo src={TempLogo} alt="Start Screen" isFullScreen={false} style={{marginBottom: '16px'}} />

                {startScreenConfig?.form?.form_title && 
              <ResponsiveTitle textAlign="center" variant="h6" fontWeight={'bold'}>
                {startScreenConfig?.form?.form_title}
              </ResponsiveTitle>}
              
              {startScreenConfig?.form?.form_description && 
              <ResponsiveTypography textAlign="center" variant="body1" style={{ marginBottom: '16px',  maxWidth: isBotSetToFullScreen ? '48%' : '70%' }}>
                {startScreenConfig?.form?.form_description}
              </ResponsiveTypography>}
            </div>
        
        
        
        <StyledForm onSubmit={handleSubmit}>

         
        
          {startScreenConfig?.form?.name && (
            <StyledInputWrapper>
              <StyledInput
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleInputChange}
                hasError={!!errors.name}
              />
              {errors.name && <StyledError>{errors.name}</StyledError>}
            </StyledInputWrapper>
          )}

          {startScreenConfig?.form?.email && (
            <StyledInputWrapper>
              <StyledInput
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
                hasError={!!errors.email}
              />
              {errors.email && <StyledError>{errors.email}</StyledError>}
            </StyledInputWrapper>
          )}

          {startScreenConfig?.form?.phone && (
            <StyledInputWrapper>
              <StyledInput
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleInputChange}
                hasError={!!errors.phone}
              />
              {errors.phone && <StyledError>{errors.phone}</StyledError>}
            </StyledInputWrapper>
          )}
          
          {startScreenConfig?.form?.submit_button && (
            <AppSmallButton  type="submit">
              {startScreenConfig.form.submit_button.text || "Submit"}
            </AppSmallButton>
          )}
        </StyledForm>
        </SecondWrapper>
      )} */}
    </StyledStartScreenWrapper>
  );
};

export default StartScreen;

const LanguageDescription = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #000;
  text-align: center;
`;

const StyledStartScreenWrapper = styled.div`
  
  width: 100%;
  // height: calc(100vh - 110px);
  // position: absolute;
  // border-radius: 10px;
  // bottom: 24px;
  // left: 0;
  height: 100%;
  background-color: #F4FAFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  z-index: 1000;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const LanguageButton = styled.button<{botConfig: any}>`
  padding: 10px 20px;
  border-radius: 19px;
  border: 0px;
  background-color: ${props => props.botConfig?.background || '#fff'};
  color: ${props => props.botConfig?.text || '#000'};
`;

const StyledInitialView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  height: 100%;
  padding: 20px;
`;
  
